export default __webpack_public_path__ + "img/pass-on.3b946748.svg";